<template>
    <div>
        <div class="tabs is-toggle is-toggle-rounded">
            <ul>
                <li v-for="route in flightRoutes" :key="route.id" :class="{'is-active': selectedRoute === route}">
                    <a @click="selectedRoute = route">{{route}}</a>
                </li>
            </ul>
        </div>

        <div v-if="selectedRoute == flightRoutes[0]">
                <div v-if="!isLoading">
                    <div>
                        <table class="table is-fullwidth is-hoverable">

                                <thead>
                                    <tr class="first-line">
                                        <th class="first-line"><pre style="background-color: #6a85a7; color: white;font-size: 22.3px;">{{Waypoint[0].Line1}}</pre></th>
                                    </tr>
                                    <tr class="second-line">
                                        <th class="second-line"><pre style="background-color: #6a85a7; color: white; font-size: 22.3px;">{{Waypoint[0].Line2}}</pre></th>
                                    </tr>
                                </thead>

                                <tbody v-for="(wi,SequenceId) in WaypointListInputList" :key="'B' + SequenceId">
                                    <tr>
                                        <td><pre style="background-color: white;font-size: 22.8px;padding:4px;">{{wi.Line1}}<datepicker placeholder="ETA" v-if="wi.input1.includes('ETA')" v-model="wi.inputeta" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled />  <span style="font-size: 15px;white-space: nowrap;">{{wi.remark}}</span></pre></td>
                                    </tr>
                                    <tr>
                                        <td><pre style="background-color: white;font-size: 22.8px;padding:4px;">{{wi.Line2}}<input class="input" type="number" placeholder="Kg" v-if="wi.input3.includes('AREMF')" v-model="wi.inputrtime" style="width: 90px" disabled/> <datepicker placeholder="ATA" v-if="wi.input2.includes('ATA')" v-model="wi.inputata" style="width: 60px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/></pre>
                                        </td>
                                    </tr>
                                        <hr style="padding: 2px;">
                                </tbody>

                        </table>
                    </div>
                </div>

                <div v-else>
                    <p>Waypoint data couldn't get...</p>
                    <loading-button/>
                </div>

        </div>

        <div v-if="selectedRoute == flightRoutes[1]">

            <div v-if="Alt1WaypointMessage != ''">
                <p>{{Alt1WaypointMessage}}</p>
            </div>

            <div v-if="!isLoading">

<!--                    <div v-for="(w,Id) in AltWaypointInputList" :key = "Id">-->
<!--                                                // Wpdt = 2 ise    alt Waypoint Header                                           -->
<!--                                                // Wpdt = 3 ise    Alt Waypoint data                                             -->
<!--                                                // Wpdt = 0 ise    tableda kullanma yukarıda bir alanda ver ayrı bir döngü içinde-->
<!--                                                                                                                //Alt1Waypoint Alt2 -->
                        <div v-for="(w,Id) in AltWaypointInputList" :key = "'Info'+Id">
                            <pre v-if="w.Wpdt == 0 && w.LineContext!=''">{{w.LineContext}}</pre>
                        </div>

                        <table class="table is-fullwidth is-hoverable">
<!--                            <thead v-for="(w,Id) in AltWaypointInputList" :key = "'Head' + Id">-->
                            <thead v-for="(w,Id) in AltWaypointInputList" :key = "'Head' + Id">
                                <tr v-if="w.Wpdt == 2" class="first-line">
                                    <th class="first-line"><pre style="background-color: #6a85a7; color: white;font-size: 15.8px;">{{w.LineContext}}</pre></th>
                                </tr>
                            </thead>
<!--                            <tbody v-for="(w,Id) in AltWaypointInputList" :key = "'Row' + Id">-->
                            <tbody v-for="(w,Id) in AltWaypointInputList" :key = "'Row' + Id">
                                <tr v-if="w.Wpdt == 3">
                                    <td><pre style="background-color: white;font-size: 15.8px;padding: 0.25rem 1.5rem;">{{w.LineContext}}<datepicker placeholder="ETA" v-if="w.input1.includes('ETA')" v-model="w.inputeta" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/><datepicker placeholder="ATA" v-if="w.input2.includes('ATA')" v-model="w.inputata" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/><datepicker placeholder="TIME" v-if="w.input3.includes('RTIME')" v-model="w.inputrtime" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/></pre></td>
                                </tr>
                            </tbody>
                        </table>
<!--                    </div>-->
            </div>


            <div v-else>
                <p>There is no Dest Alternate for this flight.</p>
                <loading-button/>
            </div>
        </div>




        <div v-if="selectedRoute == flightRoutes[2]">

            <div v-if="Alt2WaypointMessage != ''">
                <p>{{Alt2WaypointMessage}}</p>
            </div>
            <div v-if="!isLoading">

                <!--                    <div v-for="(w,Id) in AltWaypointInputList" :key = "Id">-->
                <!--                                                // Wpdt = 2 ise    alt Waypoint Header                                           -->
                <!--                                                // Wpdt = 3 ise    Alt Waypoint data                                             -->
                <!--                                                // Wpdt = 0 ise    tableda kullanma yukarıda bir alanda ver ayrı bir döngü içinde-->
                <!--                             //Alt1Waypoint Alt2 -->
                <div v-for="(w,Id) in AltWaypointInputList2" :key = "'Info2'+Id">
                    <pre v-if="w.Wpdt == 0 && w.LineContext!=''">{{w.LineContext}}</pre>
                </div>

                <table class="table is-fullwidth is-hoverable">
                    <!-- <thead v-for="(w,Id) in AltWaypointInputList2" :key = "'Head2' + Id">-->
                    <thead v-for="(w,Id) in AltWaypointInputList2" :key = "'Head2' + Id">
                    <tr v-if="w.Wpdt == 2" class="first-line">
                        <th class="first-line"><pre style="background-color: #6a85a7; color: white;font-size: 15.8px;">{{w.LineContext}}</pre></th>
                    </tr>
                    </thead>
                    <!-- <tbody v-for="(w,Id) in AltWaypointInputList2" :key = "'Row2' + Id">-->
                    <tbody v-for="(w,Id) in AltWaypointInputList2" :key = "'Row2' + Id">
                    <tr v-if="w.Wpdt == 3">
                        <td><pre style="background-color: white;font-size: 15.8px;padding: 0.25rem 1.5rem;">{{w.LineContext}}<datepicker placeholder="ETA" v-if="w.input1.includes('ETA')" v-model="w.inputeta" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/><datepicker placeholder="ATA" v-if="w.input2.includes('ATA')" v-model="w.inputata" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/><datepicker placeholder="TIME" v-if="w.input3.includes('RTIME')" v-model="w.inputrtime" style="width: 50px" :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" disabled/></pre></td>
                    </tr>
                    </tbody>

                </table>
                <!-- </div>-->
            </div>


            <div v-else>
                <p>There is no Dest Alternate 2  for this flight.</p>
                <loading-button/>
            </div>
        </div>



        <div v-if="selectedRoute == flightRoutes[3]">

            <div v-if="DepAltWaypointMessage != ''">
                <p>{{DepAltWaypointMessage}}</p>
            </div>

            <div v-if="!isLoading && DepAltWaypoint" >

                <!--                    <div v-for="(w,Id) in AltWaypointInputList" :key = "Id">-->
                <!--                                                // Wpdt = 2 ise    alt Waypoint Header                                           -->
                <!--                                                // Wpdt = 3 ise    Alt Waypoint data                                             -->
                <!--                                                // Wpdt = 0 ise    tableda kullanma yukarıda bir alanda ver ayrı bir döngü içinde-->
                <!--                             //Alt1Waypoint Alt2 -->
                <div v-for="(w,Id) in DepAltWaypoint.AlternateWaypointList" :key = "'Info2'+Id">
                    <pre v-if="w.Wpdt == 0 && w.LineContext!=''">{{w.LineContext}}</pre>
                </div>


            </div>

            <div v-else>

            </div>
        </div>



    </div>

</template>

<script>

    import Datepicker from "vue-bulma-datepicker";
    import {mapState} from "vuex";
    import {loadingMixin} from "../../../utils/mixins";
    import LoadingButton from "../../../components/ui/LoadingButton";

    export default {
        name: "FuelTimeCheck",
        mixins: [loadingMixin],
        props: ["id", "flight"],
        components: {
            LoadingButton,
            Datepicker,
        },
        data() {
            return {

                flightRoutes: [this.flight.adep+"-"+this.flight.aarr,"Dest Alt","Dest Alt2","Take Off Alt"] ,

                selectedRoute: null,
                localWPList : [],
                WaypointListInputList : [],
                depelev : "",
                arrelev : "",
                elevstat : 0,
                elevError : "",

                AltWaypoint : null,
                AltWaypoint2 : null,


                AltWaypointInputList :[],
                AltWaypointInputList2 :[],


                Waypoint : null,
                waypointstat: 0,
                waypointError :"",
                altwaypointstat : 0,
                altwaypointError : "",

                DestAlt1Waypoint : null,
                DestAlt2Waypoint : null,
                DepAltWaypoint : null,


                Alt1WaypointInputList : null,
                Alt2WaypointInputList : null,

                Alt1WaypointMessage : "",
                Alt2WaypointMessage : "",
                DepAltWaypointMessage : ""

            }
        },

        computed: {


            ...mapState("ipadmain",[ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            // ...mapState("fueltimecheck",["WaypointJsonData","OfptextJsonData","OfpFlightJsondata","WaypointTxtJsonData"]),

        },

       async created() {

            this.showLoading();

            this.depelev = this.EFF_Json_Data.poOFP.DepElev;
            this.arrelev = this.EFF_Json_Data.poOFP.ArrElev;
            //this.Waypoint = null;
            this.Waypoint = this.EFF_Json_Data.poWaypoint.WaypointList;

            this.filteredWaypointTextList = []; //this.EFF_Json_Data.poWaypoint.WaypointList;
            this.WaypointListInputList = [];

            this.Alt1WaypointInputList = null;


            let altWaypointsList = this.EFF_Json_Data.poAltWaypointGroups;


            let i =0;
            for (i = 0; i < altWaypointsList.length; i++) {

               if(altWaypointsList[i].AltNo =="1" && altWaypointsList[i].AltNo)
               {
                   this.DestAlt1Waypoint = altWaypointsList[i];
                   this.AltwaypointListInputTagPusher();

               }
               if(altWaypointsList[i].AltNo =="2" && altWaypointsList[i].AltNo)
               {
                   this.DestAlt2Waypoint = altWaypointsList[i];
                   this.Alt2waypointListInputTagPusher();

               }
               if(altWaypointsList[i].AltNo =="T" && altWaypointsList[i].AltNo)
               {
                   this.DepAltWaypoint = altWaypointsList[i];

               }


           }

           if(this.DestAlt1Waypoint == null)
           {
               this.Alt1WaypointMessage = "There is no Dep Alternate for this flight.";

           }
            if(this.DestAlt2Waypoint == null)
            {
                this.Alt2WaypointMessage = "There is no Dest Alternate 2 for this flight.";

            }
           if (this.DepAltWaypoint == null)
           {
               this.DepAltWaypointMessage = "There is no Dep Alternate for this flight.";

           }



            this.WaypointListInputTagPusher();




            // render process de çizdirme işlemi gerçekleştirilsin.

            this.hideLoading();

       },
       methods: {

           // ...mapActions("fueltimecheck", ["getJsonDataWaypointOfpText"]),

           WaypointListInputTagPusher()
           {
               for (let i = 0; i < this.Waypoint.length; i++)
               {
                   if (this.Waypoint[i].Line1.includes("[ETA")  || this.Waypoint[i].Line2.includes("[AREMF"))
                   {
                           //let line1, line2;

                           let in1 = "" ;
                           let in2 = "" ;
                           let in3 = "" ;
                           //let Line1 = "" ;
                           //let Line2 = "" ;

                           if (this.Waypoint[i].Line1.includes("[ETA") && this.Waypoint[i].Line1.includes("]"))
                           {
                               in1 ="ETA"+this.Waypoint[i].SequenceId;

                               this.Waypoint[i].Line1 = this.Waypoint[i].Line1.replace("[ETA"+this.Waypoint[i].SequenceId+"]","");
                           }

                           if (this.Waypoint[i].Line2.includes("[AREMF"))
                           {
                                this.Waypoint[i].Line2 = this.Waypoint[i].Line2.replace("[AREMF"+this.Waypoint[i].SequenceId+"]","");
                                this.Waypoint[i].Line2 = this.Waypoint[i].Line2.replace("[ATA"+this.Waypoint[i].SequenceId+"]","");

                                in2 = "ATA" + this.Waypoint[i].SequenceId;
                                in3 = "AREMF" + this.Waypoint[i].SequenceId;
                           }

                            // buraya ipadden gelen inputu döndürerek direk alttaki listeye eklesin.

                            // eslint-disable-next-line no-unused-vars
                            let aremf = "0";
                            let atatime = "0000";
                            let etatime = "0000";
                            let remark = "";
                            var c = i-1;
                            //console.log(c);
                            //console.log(this.InputsObject.IF.ftcWaypoints[c]);
                            if (this.InputsObject.IF.ftcWaypoints)
                            {
                                if(this.InputsObject.IF.ftcWaypoints[c]){atatime =  this.InputsObject.IF.ftcWaypoints[c].ata;}
                                if(this.InputsObject.IF.ftcWaypoints[c]){aremf = this.InputsObject.IF.ftcWaypoints[c].aremf;}
                                if(this.InputsObject.IF.ftcWaypoints[c]){etatime =  this.InputsObject.IF.ftcWaypoints[c].actualEta;}
                                if(this.InputsObject.IF.ftcWaypoints[c]){remark =  this.InputsObject.IF.ftcWaypoints[c].remarks;}
                            }

                            this.WaypointListInputList.push({SequenceId : this.Waypoint[i].SequenceId ,Line1 : this.Waypoint[i].Line1, Line2 : this.Waypoint[i].Line2 , input1 : in1, input2 : in2, input3 : in3, inputeta : etatime, inputata : atatime, inputrtime : aremf ,remark : remark});

                            //this.filteredWaypointTextList.push({Line1 : Line1, Line2 : Line2, input1 : in1,input2 : in2,input3 : in3, inputeta:"",inputata : "",inputrtime:""});

                   }
               }
           },

           AltwaypointListInputTagPusher()
           {

                // Wpdt = 2 ise    alt Waypoint Header
                // Wpdt = 3 ise    Alt Waypoint data
                // Wpdt = 0 ise tableda kullanma yukarıda bir alanda ver ayrı bir döngü içinde

               //  AlternateWaypointList
               this.AltWaypoint = this.DestAlt1Waypoint.AlternateWaypointList;

               if(!this.AltWaypoint)
               {
                   // Dest Alternate Waypoints couldn't get.
                   return;
               }

               var input_i=0;
               for (let i = 0; i < this.AltWaypoint.length; i++) {

                   if (this.AltWaypoint[i].LineContext.includes("[ETA") && this.AltWaypoint[i].LineContext.includes("]") && this.AltWaypoint[i].Wpdt == 3)
                   {

                       this.AltWaypoint[i].LineContext = this.AltWaypoint[i].LineContext.replace("[ETA"+this.AltWaypoint[i].SequenceId+"]/[ATA"+this.AltWaypoint[i].SequenceId+"] [RTIME"+this.AltWaypoint[i].SequenceId+"]","");

                       let in1 = "ETA"+this.AltWaypoint[i].SequenceId;
                       let in2 = "ATA"+this.AltWaypoint[i].SequenceId;
                       let in3 = "RTIME"+this.AltWaypoint[i].SequenceId;

                       let AltAta = "0000";
                       let AltEta = "0000";
                       let AltRTime = "0000";

                       if (this.InputsObject.IF.ftcAlternate1)
                       {
                           //console.log("ftcalternate1 :"+input_i)
                           if (this.InputsObject.IF.ftcAlternate1[input_i]){
                           //console.log(this.InputsObject.IF.ftcAlternate1[input_i])
                               if (this.InputsObject.IF.ftcAlternate1[input_i].ata)
                               {
                                   AltAta = this.InputsObject.IF.ftcAlternate1[input_i].ata;
                               }
                               if (this.InputsObject.IF.ftcAlternate1[input_i].eta)
                               {
                                   AltEta = this.InputsObject.IF.ftcAlternate1[input_i].eta;
                               }
                               if (this.InputsObject.IF.ftcAlternate1[input_i].rTime)
                               {
                                   AltRTime = this.InputsObject.IF.ftcAlternate1[input_i].rTime;
                               }
                           }
                       }

                       input_i ++;

                       //let AltAta = (this.ftcAlternate1[i]) ?  this.ftcAlternate1[i].ata  : "";
                       //let AltEta = (this.ftcAlternate1[i]) ?  this.ftcAlternate1[i].eta  : "";
                       //let AltRTime = (this.ftcAlternate1[i]) ?  this.ftcAlternate1[i].rTime  : "";

                       this.AltWaypointInputList.push({LineContext : this.AltWaypoint[i].LineContext, SequenceId : this.AltWaypoint[i].SequenceId, Wpdt : this.AltWaypoint[i].Wpdt , input1 : in1 , input2 : in2 , input3 : in3 , inputeta :AltEta ,inputata : AltAta , inputrtime : AltRTime});

                   }
                   else
                   {
                       this.AltWaypointInputList.push({LineContext : this.AltWaypoint[i].LineContext, SequenceId : this.AltWaypoint[i].SequenceId, Wpdt : this.AltWaypoint[i].Wpdt , input1 : "" , input2 : "" , input3 : "" , inputeta : "" ,inputata : "" , inputrtime : ""  });
                   }

               }

           },

           Alt2waypointListInputTagPusher()
           {
               // AlternateWaypointList
               var input_i=0;
               this.AltWaypoint2 = this.DestAlt2Waypoint.AlternateWaypointList;


               if(!this.AltWaypoint2)
               {
                   // Dest Alternate 2 Waypoints couldn't get.
                   return;
               }
               for (let i = 0; i < this.AltWaypoint2.length; i++) {

                   if (this.AltWaypoint2[i].LineContext.includes("[ETA") && this.AltWaypoint2[i].LineContext.includes("]") && this.AltWaypoint2[i].Wpdt == 3)
                   {

                       this.AltWaypoint2[i].LineContext = this.AltWaypoint2[i].LineContext.replace("[ETA"+this.AltWaypoint2[i].SequenceId+"]/[ATA"+this.AltWaypoint2[i].SequenceId+"] [RTIME"+this.AltWaypoint2[i].SequenceId+"]","");

                       let in1 = "ETA"+this.AltWaypoint2[i].SequenceId;
                       let in2 = "ATA"+this.AltWaypoint2[i].SequenceId;
                       let in3 = "RTIME"+this.AltWaypoint2[i].SequenceId;

                       let AltAta = "0000";
                       let AltEta = "0000";
                       let AltRTime = "0000";

                       if (this.InputsObject.IF.ftcAlternate2)
                       {
                           //console.log("ftcalternate2 :"+input_i)
                           if (this.InputsObject.IF.ftcAlternate2[input_i]){
                               //console.log(this.InputsObject.IF.ftcAlternate2[input_i])
                               if (this.InputsObject.IF.ftcAlternate2[input_i].ata)
                               {
                                   AltAta = this.InputsObject.IF.ftcAlternate2[input_i].ata;
                               }
                               if (this.InputsObject.IF.ftcAlternate2[input_i].eta)
                               {
                                   AltEta = this.InputsObject.IF.ftcAlternate2[input_i].eta;
                               }
                               if (this.InputsObject.IF.ftcAlternate2[input_i].rTime)
                               {
                                   AltRTime = this.InputsObject.IF.ftcAlternate2[input_i].rTime;
                               }
                           }
                       }

                       input_i ++;

                       //let AltAta = (this.ftcAlternate2[i]) ?  this.ftcAlternate2[i].ata  : "";
                       //let AltEta = (this.ftcAlternate2[i]) ?  this.ftcAlternate2[i].eta  : "";
                       //let AltRTime = (this.ftcAlternate2[i]) ?  this.ftcAlternate2[i].rTime  : "";

                       this.AltWaypointInputList2.push({LineContext : this.AltWaypoint2[i].LineContext, SequenceId : this.AltWaypoint2[i].SequenceId, Wpdt : this.AltWaypoint2[i].Wpdt , input1 : in1 , input2 : in2 , input3 : in3 , inputeta :AltEta ,inputata : AltAta , inputrtime : AltRTime});

                   }
                   else
                   {
                       this.AltWaypointInputList2.push({LineContext : this.AltWaypoint2[i].LineContext, SequenceId : this.AltWaypoint2[i].SequenceId, Wpdt : this.AltWaypoint2[i].Wpdt , input1 : "" , input2 : "" , input3 : "" , inputeta : "" ,inputata : "" , inputrtime : ""  });
                   }

               }

           }
       },
       mounted()
       {
            this.selectedRoute = this.flightRoutes[0];
       },

    }
</script>

<style scoped>

    hr {
        position: absolute;
        margin-top: -10px;
        padding: 10px;
        border: 1px;
        width: 100%;
    }

    .tabs.is-toggle ul {
        border-bottom: none;
        place-content: center;
    }

    .tabs.is-toggle li.is-active a {
        background-color: #6a85a7;
        border-color: #6a85a7;
        color: #fff;
        z-index: 1;
    }

    .table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 19px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .table td {
        border: 0px;

        padding: 10px;
    }

    .table {
        overflow-y: scroll;
        height: 780px;
    }

    .flatpickr {
        padding: 0;
        margin: 0;
    }

    .flatpickr-input {
        padding: 5px;
        margin: 0;
    }

    .second-line{
        top: 37px !important;
    }

    .pad-line{
        padding: .5rem 1.5rem;
        background-color: #f0f0f0;
    }

</style>
